import React, { createContext } from 'react';
import "./index.scss";
import App from './App';
import Store from './store/store';
import ReactDOM from "react-dom";

interface State {
  store: Store;
}

const store = new Store();

export const Context = createContext<State>({ store })

ReactDOM.render(
  <Context.Provider value={{ store }}>
    <App />
  </Context.Provider>,
  document.querySelector("#root")
);

